<template>
    <div>
        <v-dialog v-model="pmrewardbonusdialog" max-width="1200px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" style="margin-top: 25px ; margin-left: 25px;" v-on="on">+</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    {{ isEdit ? $t('pmrewardrecord.editBonus') : $t('pmrewardrecord.addBonus') }}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>                                    
                            <v-col cols="7" sm="7" md="7" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('pmassementrecord.finalrank')"
                                    type="text"
                                    :rules="[rules.required]"
                                    :items="rankList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.finalrank"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-spacer>
                                </v-spacer>
                            </v-col>
                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    :label="$t('appraisalrecord.factor')"
                                    type="number"
                                    :rules="[rules.required , rules.factor]"
                                    dense
                                    v-model="formData.factor"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="7" sm="7" md="7" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :rules="[rules.required]"
                                    :label="$t('pmrewardrecord.bonusfactorfreq')"
                                    type="text"
                                    :items="basicFreqList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.basicfreqid"
                                    @change="changeBasicFreqHandler(formData.basicfreqid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.basicfreqcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    :items="companyList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.companyid"
                                    @change="changeCompanyHandler(formData.companyid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.companycode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.branch')"
                                    type="text"
                                    :items="branchList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.branchid"
                                    @change="changeBranchHandler(formData.branchid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.branchcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.division')"
                                    type="text"
                                    :items="divisionList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.divisionid"
                                    @change="changeDivisionHandler(formData.divisionid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.divisioncode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.department')"
                                    type="text"
                                    :items="departmentList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.departmentid"
                                    @change="changeDepartmentHandler(formData.departmentid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.departmentcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.section')"
                                    type="text"
                                    :items="sectionList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.sectionid"
                                    @change="changeSectionHandler(formData.sectionid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.sectioncode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.unit')"
                                    type="text"
                                    :items="unitList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.unitid"
                                    @change="changeUnitHandler(formData.unitid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.unitcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.grade')"
                                    type="text"
                                    :items="gradeList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.gradeid"
                                    @change="changeGradeHandler(formData.gradeid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.gradecode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.job')"
                                    type="text"
                                    :items="jobList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.jobid"
                                    @change="changeJobHandler(formData.jobid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.jobcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>                                    
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.employmenttype')"
                                    type="text"
                                    :items="employmentTypeList"
                                    hide-selected
                                    item-value="value"
                                    item-text="text"
                                    v-model="formData.employmenttypeid"
                                    @change="changeEmploymentTypeHandler(formData.employmenttypeid)"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.code')"
                                    type="text"
                                    v-model="formData.employmenttypecode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{errMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closePmRewardRecordBonusInput">{{$t('button.cancel')}}</v-btn>
                    <v-btn color="green darken-1" text @click="savePmRewardRecordBonusInput">{{$t('button.save')}}</v-btn>
                </v-card-actions>
          </v-card>
        </v-dialog>
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
            :sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-3 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteItemHandlerAction"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
// import moment from 'moment';

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                percentage: value => !(value < 0 || value > 100) || this.$t('reportsparam.valueonetohundred'),

                factor: value => value > 0 || "The value must be greater than 0",
            },

            pmrewardbonusdialog: false,
            detailItem: this.parentObject.detailItem,
            pmassessmentrecordid: this.parentObject.pmassessmentrecordid,

            formData: {
                id: null,
                rewardrecordid: this.parentObject.rewardrecordid,
               
                
                finalrank:null,
                factor: null,

                basicfreqid: null,
                basicfreqcode: null,

                //9 parameter
                companyid: null,
                    companycode: null,
                branchid: null,
                    branchcode: null,
                divisionid: null,
                    divisioncode: null,
                departmentid: null,
                    departmentcode: null,
                sectionid: null,
                    sectioncode: null,
                unitid: null,
                    unitcode: null,
                gradeid: null,
                    gradecode: null,
                jobid: null,
                    jobcode: null,
                employmenttypeid: null,
                employmenttypecode: null,
             
                rectimestamp: null,
                stamp: null,
                updatedby: this.$store.getters.userId,
            },
            rankList: [],
            rankFullItem: [],
            basicFreqList: [],
            basicFreqFullItem: [],

            //9 Parameters for the staff
            companyList: [],
            companyFullItem: [],
            branchList: [],
            branchFullItem: [],
            divisionList: [],
            divisionFullItem: [],
            departmentList: [],
            departmentFullItem: [],
            sectionList: [],
            sectionFullItem: [],
            unitList: [],
            unitFullItem: [],
            gradeList: [],
            gradeFullItem: [],
            jobList: [],
            jobFullItem: [],
            employmentTypeList: [],
            employmentTypeFullItem: [],


            isEdit: false,//default add new item, for the title
            isErr: false,
            errMsg: '',
            isConfirm: false,
            messageConfirm:'',
            selectedItem: null,
        }
    },

    methods: {

        async loadRankMapSetOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/rankmapsetdetailbyassessment/" + this.pmassessmentrecordid
                });

                vm.rankFullItem = res.data.rec;

                vm.rankList = []; // Clear before populating
                for (let i = 0; i < vm.rankFullItem.length; i++) {
                    vm.rankList.push({
                        text: vm.rankFullItem[i].rank,
                        value: String(vm.rankFullItem[i].rank), // Convert to string
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading Ranking set detail", err);
            }
        },

        async loadBasicFreqOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/salfreq/all"
                });

                vm.basicFreqFullItem = res.data.rec;
                vm.basicFreqList = []; // Clear before populating
                for (let i = 0; i < vm.basicFreqFullItem.length; i++) {
                    vm.basicFreqList.push({
                        text: vm.basicFreqFullItem[i].basicfreqdesc,
                        value: vm.basicFreqFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading basic salary frequency option", err);
            }
        },


        changeBasicFreqHandler(id) {
            let item = this.basicFreqFullItem.find(item => item.id == id);
            this.formData.basicfreqcode = item.basicfreqcode;
        },

        async loadCompanyOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/company/all"
                });

                vm.companyFullItem = res.data.rec;
                vm.companyList = []; // Clear before populating
                for (let i = 0; i < vm.companyFullItem.length; i++) {
                    vm.companyList.push({
                        text: vm.companyFullItem[i].compnyname,
                        value: vm.companyFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading company option", err);
            }
        },


        changeCompanyHandler(id) {
            let item = this.companyFullItem.find(item => item.id == id);
            this.formData.companycode = item.compnycode;
        },

        async loadBranchOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/branch/all"
                });

                vm.branchFullItem = res.data.rec;
                vm.branchList = []; // Clear before populating
                for (let i = 0; i < vm.branchFullItem.length; i++) {
                    vm.branchList.push({
                        text: vm.branchFullItem[i].brchname,
                        value: vm.branchFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading branch option", err);
            }
        },


        changeBranchHandler(id) {
            let item = this.branchFullItem.find(item => item.id == id);
            this.formData.branchcode = item.brchcode;
        },

        async loadDivisionOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/division/all"
                });

                vm.divisionFullItem = res.data.rec;
                vm.divisionList = []; // Clear before populating
                for (let i = 0; i < vm.divisionFullItem.length; i++) {
                    vm.divisionList.push({
                        text: vm.divisionFullItem[i].divnname,
                        value: vm.divisionFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading division option", err);
            }
        },


        changeDivisionHandler(id) {
            let item = this.divisionFullItem.find(item => item.id == id);
            this.formData.divisioncode = item.divncode;
        },

        async loadDepartmentOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/department/all"
                });

                vm.departmentFullItem = res.data.rec;
                vm.departmentList = []; // Clear before populating
                for (let i = 0; i < vm.departmentFullItem.length; i++) {
                    vm.departmentList.push({
                        text: vm.departmentFullItem[i].deptname,
                        value: vm.departmentFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading department option", err);
            }
        },


        changeDepartmentHandler(id) {
            let item = this.departmentFullItem.find(item => item.id == id);
            this.formData.departmentcode = item.deptcode;
        },

        async loadSectionOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/section/all"
                });

                vm.sectionFullItem = res.data.rec;
                vm.sectionList = []; // Clear before populating
                for (let i = 0; i < vm.sectionFullItem.length; i++) {
                    vm.sectionList.push({
                        text: vm.sectionFullItem[i].sectioname,
                        value: vm.sectionFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading section option", err);
            }
        },


        changeSectionHandler(id) {
            let item = this.sectionFullItem.find(item => item.id == id);
            this.formData.sectioncode = item.sectiocode;
        },

        async loadUnitOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/unit/all"
                });

                vm.unitFullItem = res.data.rec;
                vm.unitList = []; // Clear before populating
                for (let i = 0; i < vm.unitFullItem.length; i++) {
                    vm.unitList.push({
                        text: vm.unitFullItem[i].unitname,
                        value: vm.unitFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading unit option", err);
            }
        },


        changeUnitHandler(id) {
            let item = this.unitFullItem.find(item => item.id == id);
            this.formData.unitcode = item.unitcode;
        },

        async loadGradeOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/grade/all"
                });

                vm.gradeFullItem = res.data.rec;
                vm.gradeList = []; // Clear before populating
                for (let i = 0; i < vm.gradeFullItem.length; i++) {
                    vm.gradeList.push({
                        text: vm.gradeFullItem[i].grddesc,
                        value: vm.gradeFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading grade option", err);
            }
        },


        changeGradeHandler(id) {
            let item = this.gradeFullItem.find(item => item.id == id);
            this.formData.gradecode = item.grdcode;
        },

        async loadJobOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/job/all"
                });

                vm.jobFullItem = res.data.rec;
                vm.jobList = []; // Clear before populating
                for (let i = 0; i < vm.jobFullItem.length; i++) {
                    vm.jobList.push({
                        text: vm.jobFullItem[i].jobtitle,
                        value: vm.jobFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading job option", err);
            }
        },


        changeJobHandler(id) {
            let item = this.jobFullItem.find(item => item.id == id);
            this.formData.jobcode = item.jobcode;
        },

        async loadEmploymentTypeOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/emptype/all"
                });

                vm.employmentTypeFullItem = res.data.rec;
                vm.employmentTypeList = []; // Clear before populating
                for (let i = 0; i < vm.employmentTypeFullItem.length; i++) {
                    vm.employmentTypeList.push({
                        text: vm.employmentTypeFullItem[i].emptypedesc,
                        value: vm.employmentTypeFullItem[i].id,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading employment type option", err);
            }
        },


        changeEmploymentTypeHandler(id) {
            let item = this.employmentTypeFullItem.find(item => item.id == id);
            this.formData.employmenttypecode = item.emptype;
        },

        modifyItemHandler(item) {
            this.isEdit = true;
            this.pmrewardbonusdialog = true;
            this.formData = item;
        },

        deleteItemHandler(item) {
            this.messageConfirm=this.$t('pmrewardrecord.deleterowdataconfirm');
            this.selectedItem = item;
            this.isConfirm=true;
        },

        async deleteItemHandlerAction() {
            const vm = this;

            if (!this.selectedItem) {
                console.error("❌ No item selected for deletion!");
                return;
            }

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                console.error("❌ No permission to delete");
                return false;
            }

            try {
                await this.$store.dispatch('delete', {
                    url: "/pmrewardbonus/" + vm.selectedItem.id
                });

                const index = vm.detailItem.findIndex(detail => detail.id === vm.selectedItem.id);
                if (index !== -1) {
                    vm.detailItem.splice(index, 1);
                }

                vm.selectedItem = null;  // 🔹 Clear after deletion
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error during deletion:", err);
            } finally {
                vm.isConfirm = false;  // 🔹 Close confirmation dialog
            }
        },

        async savePmRewardRecordBonusInput() {
            try {
                if (this.isEdit) { // Edit
                    if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                        console.error("❌ No permission to edit");
                        return false;
                    }

                    const res = await this.$store.dispatch('put', {
                        url: "/pmrewardbonus/" + this.formData.id,
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        try {//force to get the latest data from the view
                            await this.refreshDetailItemList();

                            this.pmrewardbonusdialog = false;
                            this.isEdit = false;
                            this.resetSelections();
                        } catch (err) {//in case of error, just set the updated record in the detailItem 
                            const updatedRecord = res.data.result;
                            const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                            if (index !== -1) {
                                this.$set(this.detailItem, index, updatedRecord);
                            } else {
                                console.warn("⚠️ Record not found in detailItem.");
                            }
                            this.pmrewardbonusdialog = false;
                            this.isEdit = false;
                            this.resetSelections();
                        }  
                        
                    }
                } else { // Add
                    if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                        console.error("❌ No permission to add");
                        return false;
                    }

                    const res = await this.$store.dispatch('post', {
                        url: "/pmrewardbonus/create",
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        try {//force to get the latest data from the view
                            await this.refreshDetailItemList();

                            this.pmrewardbonusdialog = false;
                            this.resetSelections();
                        } catch (err) {//in case of error, just push the latest record in the detail item 
                            const insertedRecord = res.data.result;
                            this.detailItem.push(insertedRecord);
                            this.pmrewardbonusdialog = false;
                            this.resetSelections();
                        }  
                    }
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                console.error("❌ Error in processing:", err);
            }
        },

        closePmRewardRecordBonusInput() {
            this.pmrewardbonusdialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            this.resetSelections();
        },
                
        resetSelections() {
            this.formData = {
                id:null,
                rewardrecordid: this.parentObject.rewardrecordid,
                rectimestamp: null,
                stamp: null,
                finalrank: null,
                factor: null,

                basicfreqid: null,
                basicfreqcode: null,

                companyid: null,
                companycode: null,
                branchid: null,
                branchcode: null,
                divisionid: null,
                divisioncode: null,
                departmentid: null,
                departmentcode: null,
                sectionid: null,
                sectioncode: null,
                unitid: null,
                unitcode: null,
                gradeid: null,
                gradecode: null,
                jobid: null,
                jobcode: null,
                employmenttypeid: null,
                employmenttypecode: null,

                updatedby: this.$store.getters.userId,
            };
        },

        async refreshDetailItemList(){
            this.fullrecord=[];
            const res = await this.$store.dispatch('get', { url: "/pmrewardbonus/" + this.parentObject.rewardrecordid});
            this.fullrecord = res.data.rec;
            this.detailItem=[];//clear the detail item
            for (let i = 0; i < this.fullrecord.length; i++) {
                this.detailItem.push(this.fullrecord[i]);
            }
        }

    },

    async mounted() {
        try {
            await this.loadRankMapSetOption();
            await this.loadBasicFreqOption();

            await this.loadCompanyOption();
            await this.loadBranchOption();
            await this.loadDivisionOption();
            await this.loadDepartmentOption();
            await this.loadSectionOption();
            await this.loadUnitOption();
            await this.loadGradeOption();
            await this.loadJobOption();
            await this.loadEmploymentTypeOption();
        } catch (err) {
            this.isErr = true;
            this.errMsg = err.message || "An error occurred while loading data";
            console.error("❌ Error in mounted:", err);
        }
    },

}
</script>